import type { Types } from '@common/models';
import { tuneSubscribe } from '@common/talkn-config';
import Sequence from '@common/Sequence';

type Action = {
  type: string;
  posts: (Types['Post'] & { deleted?: boolean })[];
};

// 重複チェック用のヘルパー関数
const deduplicatePosts = (posts: Types['Post'][]): Types['Post'][] => {
  const seen = new Set<string>();
  return posts.filter(post => {
    // postのユニークキーを生成（uid + connection + createTime）
    const key = `${post.uid}_${post.connection}_${post.createTime || post.content}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export default (state: Types['Post'][] = [], action: Action) => {
  switch (action.type) {
    case 'API_TO_SERVER[REQUEST]:changeThread':
      return [];
    case 'SERVER_TO_API[EMIT]:getMore':
      if (action.posts && action.posts.length > 0) {
        return deduplicatePosts([...action.posts, ...state]);
      }
      break;
    case 'SERVER_TO_API[EMIT]:tune':
    case 'SERVER_TO_API[EMIT]:fetchPosts':
    case `${Sequence.SERVER_TO_API_BROADCAST}${tuneSubscribe.statePosts}`:
      if (action.posts && action.posts.length > 0) {
        const deletions = action.posts.filter(p => p.deleted);
        if (deletions.length > 0) {
          return state.filter(p => !deletions.some(d => d.uid === p.uid && d.replyToId === p.replyToId && d.content === p.content));
        }
        return deduplicatePosts([...state, ...action.posts]);
      }
      break;
  }
  return state;
};
